export default __webpack_public_path__ + "static/media/HDTX_LKTT 2019.9c295955.pdf";